import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=788c51fc&scoped=true&"
import script from "./EmojiPicker.vue?vue&type=script&lang=js&"
export * from "./EmojiPicker.vue?vue&type=script&lang=js&"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=788c51fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c51fc",
  null
  
)

export default component.exports